export default __webpack_public_path__ + "static/media/logo.6319cc3a.png";